import React from 'react';
import styled from 'styled-components';

import CapitalizedButton from '../../../modules/custom-grouping/components/common/CapitalizedButton'
import { IEnrollmentDetails } from './enrollmentHistoryTypes';

const StylesCenterItem = styled.div`
    text-align: center;
    .gi-button__secondary{
        width:100%;
    }
    
`;

const PlanBenefits = (props: { enrollmentDetails: IEnrollmentDetails }) => {
    const { enrollmentDetails } = { ...props };
    const planDetailsUrl = `/hix${enrollmentDetails.benefitDetailsUrl}`
    return (
        <StylesCenterItem className="col-xs-12 col-md-6 col-lg-6">
            <img alt="logo" src={enrollmentDetails.planLogoUrl}></img>
            <p>
                <span className='link-text'> {enrollmentDetails.planName}</span>
            </p>
            <a data-testid="viewBenefitDetailsBtn" target="_blank" rel="noopener noreferrer" href={planDetailsUrl}>
                <CapitalizedButton id="viewBenefitDetailsBtn" variant='secondary' labelId='indportal.enrollments.viewBenefitDetails' />
            </a>
        </StylesCenterItem>
    );
};

export default PlanBenefits;